<template>
  <!-- 员工列表 -->
  <van-popup
    v-model="isShow"
    @close="close()"
    width="100%"
    class="selectStaff"
    :close-on-click-overlay="false"
    :title="title"
    :style="{ width: '100%' }"
    show-footer
  >
    <template> 
        <div style="display:flex;max-height:450px;min-height:450px;flex-wrap: wrap;">
            <!-- 部门 -->
            <div class="left" style="height:400px">
                <div class="empty" style="width:100%;min-height: 250px;" v-if="!dataList.length && !loading">
                  <img src="./empty.png" alt="">
                  <span class="text">～暂时没有数据哦～</span>
                </div>
                <van-checkbox-group v-if="dataList.length" class="checkUser" :max="maxCheck" v-model="checkList">
                  <div class="item" v-for="(item,index) in dataList" :key="index">
                      <van-checkbox :name="item.id + '*110011*' + item.activityName + '*110011*' + (item.groupNo || '')">{{item.activityName}}{{item.startTime?`(${moment(item.startTime).format('YYYY-MM-DD')})`:''}}{{item.groupNo?`_${item.groupNo}`:''}}</van-checkbox>
                  </div>
                </van-checkbox-group>
            </div>
            <!-- 用户 -->
            <div class="right">
                <div class="tip">当前已选择： 
                  <!-- <el-tag
                    v-for="(item, index) in checkList"
                    :key="index"
                    @close="delDestnation(item)" closable
                    size="mini"
                    style="margin-right: 10px"
                    >{{ getRealName(item) }}</el-tag
                  > -->
                  <van-tag v-for="(item, index) in checkList"
                    :key="index" @close="delDestnation(item)" closeable size="medium" type="primary">{{ getRealName(item) }}</van-tag>
                  <!-- <span v-for="(item,index) in checkList" :key="index">{{getRealName(item)}} {{((checkList.length-1)>index)?'、':''}} </span>  -->
                </div>
            </div>
        </div>
    </template>
    <div
      class="dialog-footer"
      style="text-align: right; margin-bottom: 15px"
    >
      <van-button size="small" @click="close()">取 消</van-button>
      <van-button type="primary" size="small"  style="margin-left:20px;margin-right:15px;background:#2296ce;border-color:#2296ce;color:#fff" @click="update()"
        >确认</van-button
      >
    </div>
  </van-popup>
</template>


<script>
import moment from "moment";
import store from 'store'
import appService from "@/services/request/appService";
import { Popup,Tag,Button } from 'vant';
export default {
  props: ['max','type'],
  components: {
    [Popup.name]:Popup,
    [Tag.name]:Tag,
    [Button.name]:Button
  },
  data() {
    return {
      moment: moment,
      loading: true,
      title:'选择我的团',
      isShow:false,
      params: {
        iid:this.$route.query.iid || "",
        userId:'',
        status:'',
        groupType:'',
        queryKey: "",
        pageSize:10000,
        pageNumber:1,
      },
      departmentList:[],
      allUsers:[],//所有的用户不通过departmentId拉取
      dataList:[],
      checkList:[],
      maxCheck:1,
      postUrl:'groupInfo/getListByPerson'
    };
  },
  watch: {
    isShow: async function (val) {
      if (val) {
         switch (this.type) {
           case 1:
             this.title = '选择线路'
             this.postUrl = 'reception/activity/list'
             break;
           case 2:
             this.title = '选择我的团'
             this.postUrl = 'groupInfoTemplate/getList'
             break;
           default:
             break;
         }
          await this.getList()
          this.loading = false
      } else {
      }
    },
    "params.queryKey": function (val) {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        this.params.pageNumber = 1;
      }, 500);
    },
  },
  async mounted() {
      if(this.max){
          this.maxCheck = this.max
      }
  },
  methods: {
    handleCurrentChange(val) {
      this.params.pageNumber = val;
    },
    async getList(id){
      // groupInfo/getList
      // let res = await req.post("/groupInfo/getListByPerson", this.params);
      this.params.userId = store.get("loginData").rid
      let res = await appService.getListByPerson(this.params);
      let list = res.content
      console.log(res)
      if(list && list.length) {
        list.forEach(el=>{
          if(this.type == 1){
            el.activityName = el.title
          }
        })
        this.dataList = list;
      }
    },
    getRealName(row){
        if(row.split('*110011*')[2]){
          return row.split('*110011*')[1] + '_' + row.split('*110011*')[2]
        }else{
          return row.split('*110011*')[1]
        }
        
    },
    delDestnation(val){
      this.checkList.splice(this.checkList.indexOf(val), 1);
    },
    close(){
       this.isShow = false
    },
    update(){
        let data = []
        if(!this.checkList.length){
          this.$toast.center('至少选择一条！')
          return
        }
        this.checkList.forEach(item=>{
          this.dataList.forEach(el=>{
            if(el.id == item.split('*110011*')[0]){
              data.push(el)
            }
          })
            
        })
        console.log(data)
        if(this.maxCheck = 1){
            this.$emit("getData", data[0]);
        }else{
            this.$emit("getData", data);
        }
        this.isShow = false
        
    }

  },
};
</script>

<style lang="less" scoped>
.item-cell {
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #777;
    font-size: 12px;
}
.left{
    width: 100%;
    border-right: 1px solid #999;
    padding: 8px;
    overflow-y: auto;
    flex-shrink: 0;
    .empty{
      display: flex;
      flex-direction: column;
      align-items: center;
      img{
        width: 80%;
      }
      .text{
        font-size: 12px;
        color: #999;
      }
    }
    .checkUser{
        flex: 1;
        overflow-y: auto;
    }
    .item{
        cursor: pointer;
        font-size: 12px;
        padding: 2px 0;

        &.active{
          font-weight: 600;
          color: rgb(34, 150, 206); 
          background: aliceblue; 
        }
        
    }
}
.right{
    flex: 1;
    padding: 8px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .tip{
        padding-top: 15px;
        flex-shrink: 0;
        font-size: 12px;
    }
}
</style>


<style lang="less">
.selectStaff{
  .van-checkbox__icon{
    display:flex;
        align-items: center;
    .van-icon{
      font-size: .4em;
    }
  }
     
    .vxe-modal--content{
        padding: 0!important;
    }
    .checkUser{
        flex: 1;
        overflow-y: auto;
        .el-checkbox__inner{
          width: 12px;
          height: 12px;
        }
        .el-checkbox__label{
          font-size: 12px;
        }
    }
}
</style>